import React, { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { PillButton } from '../ui/PillButton';
import '../../styles/home.css';

// Capítulo ISCA — livro 3D + form c/ memória (sessionStorage stela.lead).
// Marcação EXATA da proposta; a lógica (POST /api/leads + dedupe) continua igual.
function readLead(): { nome: string; email: string; whatsapp: string } {
  try {
    return JSON.parse(sessionStorage.getItem('stela.lead') ?? '{}');
  } catch {
    return { nome: '', email: '', whatsapp: '' };
  }
}
function saveLead(patch: Partial<{ nome: string; email: string; whatsapp: string }>): void {
  try {
    sessionStorage.setItem('stela.lead', JSON.stringify({ ...readLead(), ...patch }));
  } catch {
    // bloqueado — segue sem memória
  }
}

export const LeadMagnet: React.FC = () => {
  const prefill = readLead();
  const [nome, setNome] = useState(prefill.nome);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // microcopy de memória aparece quando o nome já veio de um bloco acima
    if (prefill.nome) return undefined;
    return undefined;
  }, [prefill.nome]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim() || !email.trim()) {
      setError('Nome e e-mail são necessários para enviar o guia');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.post<{ ok: boolean; repeat?: boolean }>('/leads', {
        kind: 'guia',
        nome: nome.trim(),
        email: email.trim().toLowerCase(),
      });
      setOk(res.repeat ? 'Você já baixou o guia — reenviamos para seu e-mail.' : 'Enviado! O guia está no seu e-mail.');
      saveLead({ nome: nome.trim(), email: email.trim().toLowerCase() });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não deu para enviar agora');
    } finally {
      setLoading(false);
    }
  };
  const microcopy = readLead().nome ? 'Usamos o que você já me contou aqui em cima — é só confirmar.' : null;

  return (
    <section id="isca" className="isca">
      <div aria-hidden="true">
        <div className="book">
          <span className="t">Guia dos 5 segredos</span>
        </div>
      </div>

      <div>
        <div className="kicker">Guia grátis em PDF</div>
        <h3>Comece pelo espelho: os 5 segredos que o seu mapa natal conta sobre você</h3>
        <p>7 páginas diretas ao ponto — leitura que ninguém te deu antes. Deixe seu contato e a Stela envia o guia + o horóscopo da semana.</p>

        {ok ? (
          <div className="ok" role="status">{ok}</div>
        ) : (
          <form onSubmit={submit} noValidate>
            {microcopy && (
              <p className="text-stela-muted text-[12px] font-semibold mb-2">{microcopy}</p>
            )}
            <div className="flex flex-wrap gap-2">
              <div className="flex-1 min-w-[200px]">
                <label htmlFor="isca-nome" className="sr-only">Seu nome</label>
                <input
                  id="isca-nome"
                  type="text"
                  placeholder="Seu nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  aria-invalid={!!error}
                  aria-describedby={error ? 'isca-error' : undefined}
                />
              </div>
              <div className="flex-1 min-w-[200px]">
                <label htmlFor="isca-email" className="sr-only">Seu melhor e-mail</label>
                <input
                  id="isca-email"
                  type="email"
                  placeholder="Seu melhor e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-invalid={!!error}
                  aria-describedby={error ? 'isca-error' : undefined}
                />
              </div>
              <PillButton type="submit" variant="gold" disabled={loading}>
                {loading ? 'Enviando…' : 'Baixar guia grátis'}
              </PillButton>
            </div>
            {error && (
              <p id="isca-error" role="alert" style={{ color: '#E08C8C', fontSize: 12.5, marginTop: 8 }}>
                {error}
              </p>
            )}
          </form>
        )}
        <p className="tiny">Nada de spam; unsubscribe em 1 clique.</p>
      </div>
    </section>
  );
};